import { useEffect } from 'react';

import {
  getCouponPendingSummary,
  getGiftCouponSettlementSummary,
} from '@shared/api/couponSettlement/couponSettlement.controller';
import { GiftCouponSettlementSummaryItem } from '@shared/api/couponSettlement/couponSettlement.interface';
import { useAsyncFn } from 'react-use';

import { ROLE } from '../utils/coupon-settlement.utils';

// ─────────────────────────────────────────────
// useAgencyUnifiedSettlementData
//
// 통합(월별 합계) 화면에서 쿠폰형 쪽 숫자를 가져온다. 배송형은 기존
// useAgencyGiftSettlementData를 그대로 쓰고(같은 데이터를 배송형 탭과 공유),
// 여기서는 쿠폰형 정산서 요약 + 미정산(집계 전) 순액만 추가로 부른다.
// 둘 다 lines 없는 경량 API라 진입 비용이 작다.
// ─────────────────────────────────────────────

export interface AgencyUnifiedSettlementData {
  /** 쿠폰형 정산서 목록 요약 (Draft/Paid 전부) */
  couponItems: GiftCouponSettlementSummaryItem[] | undefined;
  couponLoading: boolean;
  /** 쿠폰형 미정산(아직 정산서로 안 묶인) 순액 = 발송 − 환불. 음수 가능 */
  couponPendingNet: number | undefined;
  couponPendingLoading: boolean;
}

export function useAgencyUnifiedSettlementData(): AgencyUnifiedSettlementData {
  const [{ loading: couponLoading, value: couponValue }, fetchCoupon] = useAsyncFn(
    () => getGiftCouponSettlementSummary({}, ROLE),
    [],
  );

  const [{ loading: couponPendingLoading, value: pendingValue }, fetchPending] =
    useAsyncFn(() => getCouponPendingSummary({}, ROLE), []);

  useEffect(() => {
    fetchCoupon();
    fetchPending();
  }, [fetchCoupon, fetchPending]);

  return {
    couponItems: couponValue?.items,
    couponLoading,
    couponPendingNet: pendingValue?.total.netAmount,
    couponPendingLoading,
  };
}
